import styled, { injectGlobal } from "styled-components";

import thin from "../fonts/thin.woff2";
import light from "../fonts/light.woff2";
import medium from "../fonts/medium.woff2";
import regular from "../fonts/regular.woff2";
import semibold from "../fonts/semibold.woff2";
import bold from "../fonts/bold.woff2";

injectGlobal`
  @font-face {
    font-family: Manrope;
    src: url(${thin});
    font-weight: 100;
  }
  @font-face {
    font-family: Manrope;
    src: url(${light});
    font-weight: 300;
  }
  @font-face {
    font-family: Manrope;
    src: url(${regular});
    font-weight: 500;
  }
  @font-face {
    font-family: Manrope;
    src: url(${medium});
    font-weight: 600;
  }
  @font-face {
    font-family: Manrope;
    src: url(${semibold});
    font-weight: 700;
  }
  @font-face {
    font-family: Manrope;
    src: url(${bold});
    font-weight: 900;
  }
`;

export const Style = styled.div`
  box-sizing: border-box;
  font-family: "Manrope", sans-serif;
`;

export default Style;



// WEBPACK FOOTER //
// ./src/ui/Typography.js